import React from 'react';
import { motion } from 'framer-motion';

const EmojiOption = ({ gif, label, rating, onClick, isAnimating, clickedRating, delay = 0 }) => {
  const isClicked = clickedRating === rating;
  const isOtherEmoji = isAnimating && !isClicked;

  const flyDownVariants = {
    initial: { y: 0, scale: 1, opacity: 1 },
    animate: {
      y: 100,
      scale: 0.5,
      opacity: 0,
      transition: {
        duration: 1,
        ease: "easeIn"
      }
    }
  };

  const growAndDisappearVariants = {
    initial: { y: 0, scale: 1, opacity: 1 },
    animate: {
      scale: [1, 1.5, 0],
      opacity: [1, 1, 0],
      y: [0, -20, 50],
      transition: {
        duration: 1.5,
        times: [0, 0.6, 1],
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  const disappearVariants = {
    initial: { opacity: 1, scale: 1 },
    animate: {
      opacity: 0,
      scale: 0.8,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  const optionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5, delay }
    },
    disappear: {
      opacity: 0,
      scale: 0.8,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div 
      className="emoji-option"
      variants={optionVariants}
      initial="hidden"
      animate={isOtherEmoji ? "disappear" : "visible"}
      whileHover={!isAnimating ? { y: -5, scale: 1.1 } : {}}
      whileTap={!isAnimating ? { scale: 0.95 } : {}}
      onClick={onClick}
    >
      <motion.div 
        className="emoji"
        animate={
          isOtherEmoji 
            ? disappearVariants.animate 
            : isClicked 
            ? growAndDisappearVariants.animate 
            : {}
        }
        initial={
          isOtherEmoji 
            ? disappearVariants.initial 
            : isClicked 
            ? growAndDisappearVariants.initial 
            : flyDownVariants.initial
        }
      >
        <img 
          src={gif} 
          alt={label}
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'contain',
            maxWidth: '120px',
            maxHeight: '120px',
            borderRadius: '8px'
          }}
        />
      </motion.div>
      <span className="emoji-label">{label}</span>
    </motion.div>
  );
};

export default EmojiOption;
